import { render, staticRenderFns } from "./MercadoPago.vue?vue&type=template&id=1b075b1d&scoped=true"
import script from "./MercadoPago.vue?vue&type=script&lang=js"
export * from "./MercadoPago.vue?vue&type=script&lang=js"
import style0 from "./MercadoPago.vue?vue&type=style&index=0&id=1b075b1d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b075b1d",
  null
  
)

export default component.exports